// extracted by mini-css-extract-plugin
export default {"links":"SideNavLinks_links__wJMDB"};